import React from 'react';
import Button from '../components/ui/Button';

export default function ErrorPage({ message, recovery = false }: { message?: string; recovery?: boolean }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-white">
      <div className="text-center max-w-md p-8">
        <div className="mx-auto mb-4 w-14 h-14 rounded-full border-4 border-red-500 flex items-center justify-center">
          <span className="text-red-600 text-xl font-bold">!</span>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Something went wrong</h1>
        <p className="text-gray-600 text-sm">
          {message || (recovery
            ? 'An unexpected error occurred. Reload the application to continue.'
            : 'An unexpected error occurred. Please try again later.')}
        </p>
        {recovery && (
          <Button className="mt-4" onClick={() => window.location.reload()}>
            Reload application
          </Button>
        )}
      </div>
    </div>
  );
}


